<template>
  <div>
    <div>
      <vs-table
        id="leadership-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div
              @click="addPage"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>
            <div class="flex flex-wrap items-center">
              <vs-pagination
                v-if="FilteredCount"
                v-model="page"
                :total="totalPages"
                :max="totalPages / length > 7 ? 7 : 5"
                class="mt-1"
              ></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>Image</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="designation">Designation</vs-th>
          <vs-th sort-key="role">Role</vs-th>
          <vs-th sort-key="sort_order">Sort</vs-th>
          <vs-th sort-key="is_active">Visible</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td>
              <img
                v-if="tr.image"
                :src="tr.image"
                class="rounded object-cover"
                height="60px"
                width="70px"
                :alt="tr.name"
              />
              <span v-else>-</span>
            </vs-td>
            <vs-td>
              <span
                class="cursor-pointer"
                @click.stop="toggleEditModal(tr._id, $event)"
                v-tooltip="{ content: `Edit ${tr.name}` }"
              >{{ (tr && tr.name) || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">{{ tr.designation || '-' }}</vs-td>
            <vs-td class="text-left">{{ tr.role || '-' }}</vs-td>
            <vs-td class="text-left">{{ tr.sort_order != null ? tr.sort_order : '-' }}</vs-td>
            <vs-td class="text-left">
              <vs-switch
                icon-pack="feather"
                vs-icon-on="icon-check-circle"
                vs-icon-off="icon-slash"
                color="primary"
                :value="tr.is_active"
                @click.stop="updateStatus(tr._id, !tr.is_active)"
              >
                <span slot="on"></span>
                <span slot="off"></span>
              </vs-switch>
            </vs-td>
            <vs-td>
              <div class="inline-flex">
                <vx-tooltip :text="`Edit ${module_name}`">
                  <feather-icon
                    @click.stop="toggleEditModal(tr._id, $event)"
                    icon="EditIcon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                  />
                </vx-tooltip>
                <vx-tooltip :text="`Delete ${module_name}`">
                  <feather-icon
                    @click.stop="deleteRecord(tr._id)"
                    icon="Trash2Icon"
                    svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'LeadershipList',
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Leadership'
  }),
  computed: {
    ...mapState('leadership', ['records', 'total', 'FilteredCount', 'listLoading']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },
  methods: {
    ...mapActions('leadership', {
      get: 'get',
      delete: 'delete'
    }),
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },
    handleChangePage(page) {
      this.page = page
      this.getData()
    },
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },
    getData() {
      this.get({
        order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },
    addPage() {
      this.$router.push(`/leadership/add`)
    },
    toggleEditModal(id, event) {
      const editUrl = `/leadership/${id}/edit`
      if (event.ctrlKey || event.metaKey) {
        window.open(editUrl, '_blank')
      } else {
        this.$router.push(editUrl)
      }
    },
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },
    updateStatus(id, status) {
      this.$store
        .dispatch('leadership/updateStatus', { id, status })
        .then((Success) => {
          this.getData()
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    }
  },
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#leadership-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#leadership-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },
  mounted() {
    this.getData()
  }
}
</script>
